import { AbstractControl, ValidatorFn } from '@angular/forms';
import { DigoService } from 'src/app/services/digo.service';
import { Ipdv } from 'src/app/shared/models/pdvResponse';
import { environment } from 'src/environments/environment';

let cachedPdv: Ipdv | null = null;

// ICCID´s válidos para local o integración
const TEST_ICCIDS: string[] = [
    '1111111111111111113',
    '3111111111111111111',
    '2222222222222221111',
    '3333333333333311111',
    '4441111111111111111',
    '6222222222222222222',
    '2222222222222222226',
    '9333333333333333333'
];

export function iccidValidator(digoService?: DigoService): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        // Si está vacío, no se valida (permite opcionalidad)
        if (!control.value) return null;

        // Si aún no tiene 19 dígitos, no marcamos error (el usuario sigue escribiendo)
        if (control.value.length < 19) return null;

        // Comprueba si el entorno es local o integración
        const isLocalOrIntegration = !environment.production;

        // Si el entorno es local o integración, se comprueba si el iccid recibido está dentro del array de test ICCIDs. Si está, lo da por válido.
        if (isLocalOrIntegration && TEST_ICCIDS.includes(control.value)) {
            return null; // Valid test ICCID
        }

        if (!cachedPdv && digoService) {
            digoService.getPDV().subscribe((pdv) => {
                cachedPdv = pdv;
            });
        }

        if (validateICCID(control.value, cachedPdv)) {
            return null;
        }
        return { iccid: { value: control.value } };
    };
}

function validateICCID(value, pdv?: Ipdv) {
    if (value === null) {
        return;
    }
    value = value.toString();

    if (value.startsWith('1234')) {
        return true;
    }

    let regex = /^(8934)(\d{14})(\d)$/;

    let isValid = pdv?.info?.username === 'demo_pdv' ? true : false !== regex.test(value);
    return (isValid && isValidLuhn(value));
}

function isValidLuhn(num: string) {
    const sumTable = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [0, 2, 4, 6, 8, 1, 3, 5, 7, 9]];
    let sum = 0;
    let flip = 0;

    for (let i = num.length - 1; i >= 0; i--) {
        sum += sumTable[flip++ & 0x1][num[i]];
    }

    return sum % 10 === 0;
}
